import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'
import ChaInputVehicle from '../interfaces/ChaInputVehicle.ts'
import ChaPublishResult from '../interfaces/ChaPublishResult.ts'

import { makeUrlChaDelete, makeUrlChaPublish, makeUrlChaSetPublished, makeUrlChaUpdate } from './connectionData.tsx'

const useChaPublisher = () => {
  const [errorChaPublish, setErrorChaPublish] = useState<Error | null>(null)
  const [errorChaSetPublished, setErrorChaSetPublished] = useState<Error | null>(null)
  const [errorChaDelete, setErrorChaDelete] = useState<Error | null>(null)
  const [errorChaUpdate, setErrorChaUpdate] = useState<Error | null>(null)

  const [loading, setLoading] = useState<boolean>(false)

  const chaPublish = async (vehicle: ChaInputVehicle) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlChaPublish()
      const res = await customPost<ChaPublishResult>(apiUrl, vehicle)

      setErrorChaPublish(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorChaPublish(err)
      } else {
        setErrorChaPublish(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }
  // Marca el vehiculo como yapo_publishedAt
  const chaSetPublished = async (_id: string, by: string, identifier: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlChaSetPublished()
      await customPost(apiUrl, { _id, by, identifier })

      setErrorChaSetPublished(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorChaSetPublished(err)
      } else {
        setErrorChaSetPublished(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }
  // Borra el aviso en chileautos
  const chaDelete = async (_id: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlChaDelete()
      await customPost(apiUrl, { _id: _id })

      setErrorChaDelete(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorChaDelete(err)
      } else {
        setErrorChaDelete(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Actualiza el aviso en chileautos
  const chaUpdate = async (vehicle: ChaInputVehicle, changedFields: string[], isAutoSync: boolean = false) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlChaUpdate()
      const res = await customPost<ChaPublishResult>(apiUrl, {
        vehicle,
        changedFields,
        isAutoSync,
      })

      setErrorChaUpdate(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorChaUpdate(err)
      } else {
        setErrorChaUpdate(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return {
    loading,
    chaPublish,
    errorChaPublish,
    chaSetPublished,
    errorChaSetPublished,
    chaDelete,
    errorChaDelete,
    chaUpdate,
    errorChaUpdate,
  }
}

export default useChaPublisher
